import axios from "axios";
import { toast } from "react-toastify";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

// Register User

export const registerUser = (userData) => {
  return axios
    .post(`https://stock-managment.onrender.com/api/users/register`, userData, {
      withCredentials: true,
    })
    .then((response) => {
      if (response.statusText === "OK") {
        toast.success("User Registered successfully");
      }
      return response.data;
    })
    .catch((error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      toast.error(message);
    });
};

//Login user
export const loginUser = async (userData) => {
  try {
    const response = await axios.post(
      `https://stock-managment.onrender.com/api/users/login`,
      userData,
      {
        withCredentials: true,
      }
    );
    if (response.statusText === "OK") {
      toast.success("Login successfully");
    }
    return response.data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error(message);
  }
};
//Logout user
export const logoutUser = async () => {
  try {
    await axios.get(`https://stock-managment.onrender.com/api/users/logout`);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error(message);
  }
};
//Forgot password
export const forgotPassword = async () => {
  try {
    const response = await axios.post(
      `https://stock-managment.onrender.com/api/users/forgotpassword`
    );
    toast.success(response.data.message);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error(message);
  }
};
//Reset password
export const resetPassword = async (userData, resetToken) => {
  try {
    const response = await axios.put(
      `https://stock-managment.onrender.com/api/users/resetpassword/${resetToken}`,
      userData
    );
    return response.data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error(message);
  }
};
// Get Login Status
export const getLoginStatus = async () => {
  try {
    const response = await axios.get(
      `https://stock-managment.onrender.com/api/users/loggedin`
    );
    return response.data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error(message);
  }
};
